<template>
  <PublicView>
    <div id="home-page">
      <div v-for="( module, index ) in homeModules" :key="index">
        <SwiperSlide edit="false" v-if="module.type == 0" :ref="refId(module._id)" :data="module.data" />
        <FeatureCate edit="false" v-if="module.type == 1" :ref="refId(module._id)" :data="module.data" />
        <FeatureProducts edit="false" v-if="module.type == 2" :ref="refId(module._id)" :data="module.data" />
      </div>

    </div>
  </PublicView>
</template>
<script>

import PublicView from "@/components/PublicView.vue";
import SwiperSlide from "@/components/Shared/SwiperSlider.vue";
import FeatureCate from "@/components/Shared/FeatureCate.vue";
  import FeatureProducts from "@/components/Shared/FeatureProducts.vue";
export default {
  name: "HomeView",
  data() {
    return {
    };
  },
  mounted() {
    const t = this;
    this.setMetadata();
    setTimeout(() => {
      const container = t.$el.querySelector('.stickyscroll');
      if (container) {
        let direction = 1;
        setInterval(() => {
          // Nếu đã scroll đến cuối, đảo hướng
          if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
            direction = -1;
          }
          // Nếu đã scroll về đầu, đảo hướng
          if (container.scrollLeft <= 0) {
            direction = 1;
          }
          container.scrollBy({
            left: direction * 160,
            behavior: 'smooth'
          });
        }, 3000);
      }
    }, 1000);
  },
    methods: {
      refId(id) {
        return "ref" + id;
      },
        resizeImage(link, width, height) {
            const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
            if(test) {
                // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
                return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
            } else {
                return link;
            }
        },
    setMetadata() {
      let titleTag = document.querySelector("title");
      if (!titleTag) {
        titleTag = document.createElement("title");
        document.head.appendChild(titleTag);
        titleTag = document.querySelector("title");
      }
      titleTag.innerText = "Sản phẩm, thiết bị, phụ kiện Häfele chính hãng giá tốt nhất - hafelevietnam.co";
      let metaTag = document.querySelector("meta[name='title']");
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", "title");
        document.head.appendChild(metaTag);
        metaTag = document.querySelector("meta[name='title']");
      }
      metaTag.content = "Sản phẩm, thiết bị, phụ kiện Häfele chính hãng giá tốt nhất - hafelevietnam.co"
      let metaTagOg = document.querySelector("meta[property='og:title']");
      if (!metaTagOg) {
        metaTagOg = document.createElement("meta");
        metaTagOg.setAttribute("property", "og:title");
        document.head.appendChild(metaTagOg);
        metaTagOg = document.querySelector("meta[property='og:title']");
      }
      metaTagOg.content = "Sản phẩm, thiết bị, phụ kiện Häfele chính hãng giá tốt nhất - hafelevietnam.co";


      let metaDescriptionTag = document.querySelector("meta[name='description']");
      if (!metaDescriptionTag) {
        metaDescriptionTag = document.createElement("meta");
        metaDescriptionTag.setAttribute("name", "description");
        document.head.appendChild(metaDescriptionTag);
        metaDescriptionTag = document.querySelector("meta[name='description']");
      }
      metaDescriptionTag.content = "Sản phẩm, thiết bị, phụ kiện Häfele chính hãng giá tốt nhất, dịch vụ tận tâm, tư vấn nhiệt tình, hỗ trợ ky thuật tối đa. liên hệ ngay 0915761838";
      let metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
      if (!metaDescriptionTagOg) {
        metaDescriptionTagOg = document.createElement("meta");
        metaDescriptionTagOg.setAttribute("property", "og:description");
        document.head.appendChild(metaDescriptionTagOg);
        metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
      }
      metaDescriptionTagOg.content = "Sản phẩm, thiết bị, phụ kiện Häfele chính hãng giá tốt nhất, dịch vụ tận tâm, tư vấn nhiệt tình, hỗ trợ ky thuật tối đa. liên hệ ngay 0915761838";



      let metaImageTagOg = document.querySelector("meta[property='og:image']");
      if (!metaImageTagOg) {
        metaImageTagOg = document.createElement("meta");
        metaImageTagOg.setAttribute("property", "og:image");
        document.head.appendChild(metaImageTagOg);
        metaImageTagOg = document.querySelector("meta[property='og:image']");
      }
      metaImageTagOg.content = "https://hafelevietnam.co/image/catalog/header-logo.png";


      let metaUrlTag = document.querySelector("meta[property='og:url']");
      if (!metaUrlTag) {
        metaUrlTag = document.createElement("meta");
        metaUrlTag.setAttribute("property", "og:url");
        document.head.appendChild(metaUrlTag);
        metaUrlTag = document.querySelector("meta[property='og:url']");
      }
      metaUrlTag.content = "https://hafelevietnam.co/";
      let linkCanonicalTag = document.querySelector("link[rel='canonical']");
      if (!linkCanonicalTag) {
        linkCanonicalTag = document.createElement("link");
        linkCanonicalTag.setAttribute("rel", "canonical");
        document.head.appendChild(linkCanonicalTag);
        linkCanonicalTag = document.querySelector("link[rel='canonical']");
      }
      linkCanonicalTag.href = "https://hafelevietnam.co/";

    },

    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    },
    price(price) {
      const config = {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 9
      };
      return new Intl.NumberFormat('vi-VN', config).format(price);
    },
  },

  computed: {
    homeModules() {
      return this.$store.getters.homeModules;
    },
    randomProducts() {
      return this.$store.getters.randomProducts;
    },
    bepDienTu() {
      return this.$store.getters.productsByCate('67c950a5d7fbfdec4474cbbb');
    },
    chauRua() {
      return this.$store.getters.productsByCate('67c95102d7fbfdec4474cc60');
    },
    navMenu() {
      return this.$store.getters.navData;
    }
  },
  components: {
    PublicView,
    SwiperSlide,
    FeatureCate,
    FeatureProducts
  }
};
</script>
<style lang="less">
#home-slider-wrap {
  .swiper {
    border-radius: 10px;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      .image {
        img {
          width: 100%;
          height: auto;
        }
      }

      >.contents {
        position: absolute;
        top: 14%;
        left: 0;
        z-index: 100;
        width: 45%;
        left: 5%;
        text-align: left;
        transform: scale(0.6);
        transition: transform 1s;

        .label {
          font-size: 11px;
          line-height: 12px;
          margin-bottom: 3px;
          text-transform: uppercase;
          color: white;
        }

        .heading {
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
          -webkit-margin-after: 18px;
          margin-block-end: 0;
          text-transform: capitalize;
          color: white;
          letter-spacing: 1px;
        }

        .subheading {
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: white;
          display: none;
        }

        .texts {
          .text {
            p {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              line-height: 25px;
              font-size: 22px;
              margin-bottom: 2px;
              margin-top: 2px;
              color: #ad052d;
              justify-content: left;
              letter-spacing: 1px;
            }
          }
        }

        .btn {
          background: #f25c05;
          color: white;
          padding: 10px 28px;
          font-weight: 600;
          font-size: 11px;
          line-height: 1.5;
          padding: 5px 15px;
          border: none;
        }
      }

      &.swiper-slide-active {
        >.contents {
          transform: scale(1);
        }
      }
    }

  }

  .slider-wrap-2 {
    height: 30vw;
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding-top: 20px;

    .slider-2,
    .slider-3 {
      border-radius: 10px;
      overflow: hidden;
      position: relative;

      .banner-image {
        width: 100%;
        height: 100%;
        overflow: hidden;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .content {
        position: absolute;
        top: 10%;
        left: 15px;
        right: auto;
        color: white;
        text-align: left;

        h3.title {
          margin-bottom: 6px;
          font-size: 14px;
          line-height: 22px;
          width: 72%;
          font-weight: 700;
        }

        .subheading,
        .cms-label {
          display: none;
        }

        .cms-label {
          background: #ad052d;
          padding: 0px 12px;
          width: auto;
          float: left;
          border-radius: 5px;
          color: white;
          text-transform: capitalize;
          margin-bottom: 15px;
        }

        .price {
          font-size: 18px;
          line-height: 20px;
          display: flex;
          justify-content: space-between;

          >span {
            display: inline-block;
          }
        }

        .old-price {
          text-decoration: line-through;
          display: none;
        }
      }

      &.dark {
        .content {
          color: black;

        }
      }
    }

    .slider-2 {
      flex: 1;
      background-color: #f26919;

    }

    .slider-3 {
      flex: 1;
      background-color: #e0f1fb;
    }
  }
}

.base_featured_product {
  padding-top: 40px;
  text-align: left;

  .title-wrapper {
    h4 {
      font-size: 24px;
      line-height: 1.4;
      font-weight: 700;
      text-align: left;
      padding-bottom: 20px;

    }
  }

}

#product-by-brand {
  padding: 30px 0;

  a {
    color: inherit;
    text-decoration: none;
  }

  .filter__block-list-cate {
    .box-title {
      display: flex;
      justify-content: space-between;
    }

    .box-title__title {

      p {
        font-size: 24px;
        line-height: 1.4;
        font-weight: 700;
        text-align: left;
      }
    }

    .block-list-cate {
      .list-cate {
        display: flex;
        flex-wrap: wrap;
        gap: 0 20px;
        justify-content: flex-start;

        >a.item-cate {
          width: 90px;

          img {
            width: 90px;
          }
        }

      }

    }
  }
}


@media (min-width: 600px) {
  #home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          .label {
            font-size: 13px;
            line-height: 14px;
            margin-bottom: 3px;
          }

          .heading {
            font-size: 20px;
            line-height: 20px;
            font-weight: 600;
            -webkit-margin-after: 18px;
            margin-block-end: 0;
            color: white;
          }

          .subheading {
            font-size: 15px;
            font-weight: 400;
            line-height: 28px;
            display: block;
          }

          .texts {
            .text {
              p {
                line-height: 34px;
                font-size: 34px;
                margin-bottom: 8px;
                margin-top: 4px;
                letter-spacing: 1px;
              }
            }
          }

          .btn {
            font-weight: 600;
            font-size: 15px;
            line-height: 1.5;
            padding: 8px 15px;
          }
        }
      }

    }
  }



}


@media (min-width: 992px) {
  #home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          .label {
            font-size: 13px;
            line-height: 20px;
            margin-bottom: 6px;
          }

          .heading {
            font-size: 32px;
            line-height: 38px;
            margin-block-end: 6px;
            margin-block-end: 0;
            color: white;
          }

          .subheading {
            -webkit-margin-after: 15px;
            margin-block-end: 15px;
            font-size: 14px;
            line-height: 18px;
          }

          .texts {
            .text {
              p {
                line-height: 42px;
                font-size: 38px;
                margin-bottom: 15px;
                margin-top: 18px;
              }
            }
          }

          .btn {
            font-size: 13px;
            line-height: 22px;
            line-height: 1.5;
            padding: 6px 18px;
          }
        }
      }

    }
  }


}

@media (min-width: 1200px) {
  #home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 20%;

          .label {
            font-size: 18px;
            margin-bottom: 15px;
          }

          .heading {
            font-size: 48px;
            line-height: 54px;
            font-weight: 600;
            margin-block-end: 18px;
            color: white;
          }

          .subheading {
            font-size: 14px;
            font-weight: 400;
            line-height: 28px;
          }

          .texts {
            .text {
              p {
                font-size: 42px;
                font-weight: 500;
                line-height: 44px;
                margin-top: 5px;
                margin-bottom: 32px;
              }
            }
          }

          .btn {
            padding: 10px 28px;
            font-size: 14px;
            line-height: 24px;
          }
        }
      }

    }
  }



}




#home-popular-categories {
  padding-top: 40px;

  .section-title {
    font-size: 24px;
    line-height: 1.4;
    font-weight: 700;
    text-align: left;
    padding-bottom: 20px;
  }

  .stickyscroll {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    overflow-y: hidden;
    gap: 20px;

    .scroll-item {
      width: 100px;

      .image {
        border-radius: 50%;
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      .title-content {
        padding-top: 15px;

        .title {
          line-height: 1.4;
          font-weight: 700;
          font-size: 16px;
        }

        .cat-button {
          font-size: 14px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  #home-slider-wrap {
    .slider-wrap-2 {
      padding-top: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .slider-2,
      .slider-3 {
        border-radius: 10px;
      }

      .slider-2 {
        flex: 1;
        background-color: #f26919;

      }

      .slider-3 {
        flex: 1;
        background-color: #e0f1fb;
      }
    }
  }
}

@media (min-width: 992px) {
  #home-slider-wrap {
    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          h3.title {
            line-height: 22px;
            margin-bottom: 10px;
            font-size: 18px;
          }

          .subheading {
            display: none;
          }

          .cms-label {
            display: block;
            margin-right: 100%;
            margin-bottom: 6px;
          }

          .price {
            font-size: 24px;
            line-height: 26px;
          }

          .old-price {
            display: inline-block;
          }
        }
      }
    }
  }

  #home-popular-categories {
    .stickyscroll {
      .scroll-item {
        width: 140px;

        .image {
          border-radius: 50%;
          width: 140px;
          height: 140px;
          overflow: hidden;

          img {
            max-width: 100%;
          }
        }
      }
    }
  }
}

@media (min-width: 1200px) {
  #home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 7%;
        }
      }
    }

    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          h3.title {
            line-height: 22px;
            margin-bottom: 5px;
            font-size: 18px;
          }

          .subheading {
            display: block;
            padding-bottom: 3px;
            font-size: 13px;
            line-height: 22px;
          }

          .cms-label {
            display: block;
            margin-bottom: 6px;
          }

          .price {
            font-size: 26px;
            line-height: 30px;
          }
        }
      }
    }
  }
}

@media (min-width: 1400px) {
  #home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 13%;
        }
      }
    }

    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          top: calc(50% - 80px);
        }
      }
    }
  }
}
</style>